import { render, staticRenderFns } from "./weibofaceRegister.vue?vue&type=template&id=0e107194&scoped=true"
import script from "./weibofaceRegister.vue?vue&type=script&lang=js"
export * from "./weibofaceRegister.vue?vue&type=script&lang=js"
import style0 from "./weibofaceRegister.vue?vue&type=style&index=0&id=0e107194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e107194",
  null
  
)

export default component.exports